export const GENERAL_VALUES = {
  TOAST_MESSAGE_DELAY: 1500,
  RE_RENDERING_LEFT_MENU_DELAY: 3000,
  SEARCH_DELAY: 500, //after 1 second of user changes in search inputs the search operation will be started
  REDIRECTION_DELAY: 2500,
  RELOAD_PAGE_DELAY: 1000,
  SEARCH_DEBOUNCE_TIME: 300
};
